<template>
  <LoadingData v-if="isLoadingData" />
  <Questions v-else :form="form" />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import Questions from '@/components/questions/Questions.vue'

export default {
  name: 'FormQuestion',

  components: {
    LoadingData,
    Questions,
  },

  data() {
    return {
      isLoadingData: true,
      code: this.$route.params.code,
      form: null,
    }
  },

  methods: {
    async getQuestions() {
      try {
        this.form = await this.$store.dispatch('getQuestions', this.code)

        this.isLoadingData = false
      } catch (error) {
        this.isLoadingData = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }

        this.$router.push({ name: 'Home' })
      }
    },
  },

  mounted() {
    this.getQuestions()
  },
}
</script>
